import * as ko from "knockout";
import * as _ from "underscore";

// Helpers
import "fontAwesomeBindings";
import "knockoutCustomBindings";

// Models
import { AlertStructure } from "Content/ts/Models/Shared/BootstrapAlerts/alertStructure";

export interface IAlert {
    DisplayCondition: boolean | KnockoutObservable<boolean>;        // Optional

    AlertText: KnockoutObservableArray<AlertStructure>;                                         // Required/Optional    -   Required if 'SingleAlertMessage' is not provided
    SingleAlertMessage: string | KnockoutObservable<string>;                                    // Required/Optional    -   Required if 'AlertText' is not provided
}

export default class AlertBase {
    orderedAlertText: KnockoutComputed<AlertStructure[]>;
        
    alertText: KnockoutObservableArray<AlertStructure>;

    singleAlertMessage: string | KnockoutObservable<string>;
    displayCondition: boolean | KnockoutObservable<boolean>;

    constructor(params: IAlert) {
        if ((params.SingleAlertMessage == null || params.SingleAlertMessage == undefined) && (params.AlertText == null || params.AlertText == undefined)) {
            throw new Error("Please ensure 'AlertText' or 'SingleAlertMessage' has been provided when invoking this component.");
        }

        // Provided Component Properties
        this.singleAlertMessage = params.SingleAlertMessage;
        this.alertText = params.AlertText || ko.observableArray([]);
        this.displayCondition = params.DisplayCondition != null && params.DisplayCondition != undefined ? params.DisplayCondition : true;

        // Standard Component Properties
        this.orderedAlertText = ko.pureComputed(() => {
            var alerts = this.alertText();

            if (this.singleAlertMessage) {
                alerts = [{
                    Order: 0,
                    TextValue: this.singleAlertMessage
                }];

                this.alertText(alerts);
            }

            return _.sortBy(alerts, (item) => item.Order);
        });
    }
}

const alertWarningIconComponent = "alert-warning-icon";
ko.components.unregister(alertWarningIconComponent);
ko.components.register(alertWarningIconComponent, {
    viewModel: AlertBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertWarning/${alertWarningIconComponent}.html` }
});

const alertSuccessIconComponent = "alert-success-icon";
ko.components.unregister(alertSuccessIconComponent);
ko.components.register(alertSuccessIconComponent, {
    viewModel: AlertBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertSuccess/${alertSuccessIconComponent}.html` }
});

const alertDangerIconComponent = "alert-danger-icon";
ko.components.unregister(alertDangerIconComponent);
ko.components.register(alertDangerIconComponent, {
    viewModel: AlertBase,
    template: { require: `text!/Themes/Default/Content/ts/Shared/BootstrapAlerts/AlertDanger/${alertDangerIconComponent}.html` }
});